import { graphql, useStaticQuery } from "gatsby"
import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import iconCheck from '../../../assets/images/icon-check.svg'
import useBrowserMode from '../../../hooks/useBrowserMode'
import useHomeLinkMode from "../../../hooks/useHomeLinkMode"
import useLocaleMode from "../../../hooks/useLocaleMode"
import useSessionState from '../../../hooks/useSessionState'
import SessionService from '../../../services/session'
import { isAdviser } from "../../../state/utils/isAdviser"
import Button from '../../atoms/Button/Button'
import Icon from '../../atoms/Icon/Icon'
import AccountInfo from '../../molecules/accountInfo/accountInfo'
import AlertMessagge from "../../molecules/alertMessagge/alertMessagge"
import ForgetSection from '../../molecules/forgetSection/forgetSection'
import LoginSection from '../../molecules/loginSection/loginSection'
import Logo from '../../molecules/logo/logo'
import NavMenu from '../../molecules/navMenu/navMenu'
import SearchBar from '../../molecules/searchBar/searchBar'
import SignInUser from '../../molecules/signInUser/signInUser'
import LayoutPopUp from '../../organisms/layoutPopUp/layoutPopUp'
import HorizontalPopUp from '../horizontalPopUp/horizontalPopUp'
import './header.scss'

const Header = props => {

  const sliderConf = {
    dots: false,
    infinite: false,
    easing: 'ease',
    useCSS: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    className: 'f-login-sections',
    swipeToSlide: false,
    swipe: false,
    adaptiveHeight: true
  };
  const [isPopUpVisible, setPopUpVisibility] = React.useState(false);
  const [isLoaderVisible, setLoaderVisible] = React.useState(false);
  const [isLayoutVisible, setLayoutVisible] = React.useState(false);
  const [isRegisteredEmail, setRegisteredEmail] = React.useState(false);
  const [isCorrectPassword, setPassStatus] = React.useState(false);
  const [isWrongNumber, setWrongNumber] = React.useState(false);
  const [isLoginVisibleM, setLoginVisibleM] = React.useState(false);
  const [isSended, setSendedPass] = React.useState(false);
  const [phoneLastCharacthers, setphoneLastCharacthers] = React.useState('');
  const { homeLink } = useHomeLinkMode();
  const { isBrowser } = useBrowserMode();

  const adviserActive = () => {
    if (isBrowser) {
      if ((localStorage.getItem("tokenData") || sessionStorage.getItem("tokenData"))) {
        if (sessionStorage.getItem("tokenData") !== null) {
          const tokenId = JSON.parse(sessionStorage.getItem("tokenData")).idToken;
          if (isAdviser(tokenId)) {
            return true
          }
        } else {
          const tokenId = JSON.parse(localStorage.getItem("tokenData")).idToken;
          if (!isAdviser(tokenId)) return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  };

  //ContentToShow: 0 Login form - 1 Email recovery - 2 Password Recovery
  const [contentToShow, setContentToShow] = React.useState(0);
  const sliderRef = React.useRef();
  const sliderRefM = React.useRef();
  const layoutNode = React.useRef();
  const { locale } = useLocaleMode();

  const handleClickOutside = e => {
    const userIcon = document.querySelectorAll('.f-nav-link');
    if (layoutNode.current.contains(e.target) || e.target === userIcon[1]) {
      return;
    }
    setSendedPass(false);
    setPopUpVisibility(false);
    props.handleBannerPaused && props.handleBannerPaused(!isPopUpVisible);
    setContentToShow(0);
  };

  const user = props.currentUser;

  React.useEffect(() => {
    if (!props.isMobile) {
      if (isPopUpVisible) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    }
    return () => {
      if (!props.isMobile) {
        document.removeEventListener("mousedown", handleClickOutside);
      }
    };
  }, [isPopUpVisible]);

  const result = useStaticQuery(
    graphql`
      query SelectorPaises {
        allContentfulTenaPaises(sort: {fields: orden, order: ASC}, filter: {node_locale: {eq: "es-CO"}}) {
          nodes {
            id
            dominio
            codigoDeDosLetras
            titulo
            lenguaje
            prefijoTelefonico
          }
        }
      }
    `
  );

  const countriesList = result.allContentfulTenaPaises.nodes;
  const filteredCountry = result && isBrowser &&
    result.allContentfulTenaPaises.nodes.filter(country => locale.includes(country.codigoDeDosLetras));
  let currentCountry = isBrowser && filteredCountry[0].titulo;
  isBrowser && sessionStorage.setItem('currentCountry', filteredCountry[0]);

  const countriesListOne = countriesList.slice(0, [4]);
  const countriesListTwo = countriesList.slice(4);
  const countriesData = {
    countriesListOne: countriesListOne,
    countriesListTwo: countriesListTwo,
    currentCountry: currentCountry
  };

  const { isLoggedUser } = useSessionState();

  const handleCloseSession = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = homeLink;
  };

  return (
    <header>
      <div className={props.isChangePassword ? 'f-header noevents' : 'f-header'}>
        <Logo countriesData={countriesData} adviserActive={adviserActive} />
        <div className="f-nav-container">
          {props.isMobile ?
            <div className="f-nav-main-wrapper">
              <SignInUser currentPoints={props.currentPoints} handleBannerPaused={props.handleBannerPaused} isChangePassword={props.isChangePassword} currentUser={user} handleCloseSession={handleCloseSession} setLayoutVisible={setLayoutVisible} isMobile={props.isMobile} loggedUser={isLoggedUser} setPopUpVisibility={setPopUpVisibility} isPopUpVisible={isPopUpVisible} />
              <SearchBar isMobile={props.isMobile} setPopUpVisibility={setPopUpVisibility} />
              <NavMenu locale={locale} countriesData={countriesData} />
            </div> :
            <div className="f-nav-main-wrapper">
              {!adviserActive() && <SearchBar isMobile={props.isMobile} />}
              <SignInUser currentPoints={props.currentPoints} handleBannerPaused={props.handleBannerPaused} isChangePassword={props.isChangePassword} currentUser={user} handleCloseSession={handleCloseSession} isMobile={props.isMobile} loggedUser={isLoggedUser} setPopUpVisibility={setPopUpVisibility} isPopUpVisible={isPopUpVisible} />
            </div>}
          {!props.isMobile && !adviserActive() &&
            <>
              <NavMenu locale={locale} countriesData={countriesData} />
              <LayoutPopUp isVisible={isPopUpVisible} elementRef={layoutNode} >
                {contentToShow === 0 ?
                  <Slider ref={sliderRef} {...sliderConf}>
                    <LoginSection
                      title="INGRESA A TU CUENTA" sectionType={0}
                      handleNextButton={() => sliderRef.current.slickNext()}
                      handleToggleLoader={value => setLoaderVisible(value)}
                      isShowingLoader={isLoaderVisible}
                      isRegisteredEmail={isRegisteredEmail}
                      handleChangeContent={value => setContentToShow(value)}
                      handleRegisteredEmail={value => setRegisteredEmail(value)} />
                    <LoginSection
                      title="¡TE DAMOS LA BIENVENIDA!"
                      handlePrevButton={() => sliderRef.current.slickPrev()}
                      sectionType={1}
                      isShowingLoader={isLoaderVisible}
                      handleToggleLoader={value => setLoaderVisible(value)}
                      handleChangeContent={value => setContentToShow(value)}
                      isRegisteredEmail={isRegisteredEmail}
                      isCorrectPassword={isCorrectPassword}
                      handlePopUpFalse={() => setPopUpVisibility(false)}
                      handlePassStatus={value => setPassStatus(value)}
                    />
                  </Slider>
                  :
                  contentToShow === 1 ?
                    <Slider ref={sliderRefM} {...sliderConf}>
                      <ForgetSection
                        handleNextButton={() => sliderRefM.current.slickNext()}
                        handlePhoneChars={value => setphoneLastCharacthers(value)}
                        handleWrongNumber={value => setWrongNumber(value)}
                        isWrongNumber={isWrongNumber}
                        isShowingLoader={isLoaderVisible}
                        countryPrefix={filteredCountry[0].prefijoTelefonico}
                        handleToggleLoader={value => setLoaderVisible(value)}
                        forgetType={0} />
                      <div>
                        <div className="f-form-remind">
                          <p>Hemos enviado tu correo electrónico al número celular. <br />
                            <span> �? �? �? �? �? �? �? �? {phoneLastCharacthers}</span></p>
                          <div className="f-footer-login">
                            <p onClick={() => { sliderRefM.current.slickPrev() }}>¡No me llegó el mensaje!</p>
                            <Button id='f-recoveryemail-submit-btn' type="button" onClickAction={() => { sliderRefM.current.slickPrev(); setContentToShow(0); }} classname="f-button f-button--primary" text="Confirmar" />
                          </div>
                        </div>
                      </div>
                    </Slider>
                    :
                    <>
                      {!isSended ?
                        <ForgetSection
                          isShowingLoader={isLoaderVisible}
                          handleToggleLoader={value => setLoaderVisible(value)}
                          handleChangeContent={value => setContentToShow(value)}
                          handleIsSended={value => setSendedPass(value)}
                          isRegisteredEmail={isRegisteredEmail}
                          handleRegisteredEmail={value => setRegisteredEmail(value)}
                          countryPrefix={filteredCountry[0].prefijoTelefonico}
                          forgetType={1} />
                        :
                        <AlertMessagge
                          icon={<img src={iconCheck} alt="check-correct" />}
                          messagge="ÉXITO"
                          description="Hemos enviado una contraseña temporal a su correo."
                          type="success"
                          button={<Button type="button" onClickAction={() => { setContentToShow(0); setSendedPass(false); }}
                            classname="f-button f-button--primary" text="CONFIRMAR" />} />
                      }
                    </>
                }
              </LayoutPopUp>
            </>
          }
        </div>
      </div>
      {props.isMobile ?
        <>
          <HorizontalPopUp isVisible={isLayoutVisible}>
            <button onClick={() => { setLayoutVisible(false); }} className='f-header-close--active' type='button'>
              <span className='f-header-close__line f-header-close__line--active'></span>
              <span className='f-header-close__line f-header-close__line--active'></span>
            </button>
            <AccountInfo currentPoints={props.currentPoints} currentUser={user} handleCloseSession={handleCloseSession} />
          </HorizontalPopUp>
          <LayoutPopUp isVisible={isPopUpVisible} elementRef={layoutNode}>
            <div className="f-popup-wrapper">
              <a href={homeLink + 'registro'} className="f-popup-link"> REGISTRATE </a>
              <hr />
              <p className="f-popup-link" onClick={() => { setLoginVisibleM(!isLoginVisibleM); setPopUpVisibility(!isPopUpVisible) }}>INGRESA A TU CUENTA</p>
            </div>
          </LayoutPopUp>
          <HorizontalPopUp isVisible={isLoginVisibleM}>
            {contentToShow === 0 ?
              <>
                <button onClick={() => setLoginVisibleM(!isLoginVisibleM)} className='f-header-close--active' type='button'>
                  <span className='f-header-close__line f-header-close__line--active'></span>
                  <span className='f-header-close__line f-header-close__line--active'></span>
                </button>
                <Slider ref={sliderRef} {...sliderConf}>

                  <LoginSection
                    title="INGRESA A TU CUENTA" sectionType={0}
                    handleNextButton={() => sliderRef.current.slickNext()}
                    handleToggleLoader={value => setLoaderVisible(value)}
                    isRegisteredEmail={isRegisteredEmail}
                    isShowingLoader={isLoaderVisible}
                    handleChangeContent={value => setContentToShow(value)}
                    handleRegisteredEmail={value => setRegisteredEmail(value)} />

                  <LoginSection
                    title="¡TE DAMOS LA BIENVENIDA!"
                    handlePrevButton={() => sliderRef.current.slickPrev()}
                    sectionType={1}
                    handleToggleLoader={value => setLoaderVisible(value)}
                    handleChangeContent={value => setContentToShow(value)}
                    isShowingLoader={isLoaderVisible}
                    isRegisteredEmail={isRegisteredEmail}
                    handlePopUpFalse={() => { setLoginVisibleM(false); setPopUpVisibility(false); }}
                    isCorrectPassword={isCorrectPassword}
                    handlePassStatus={value => setPassStatus(value)}
                  />

                </Slider>
              </>
              :
              contentToShow === 1 ?
                <>
                  <button onClick={() => { setContentToShow(0); sliderRefM.current.slickPrev() }} className='f-header-close--active' type='button'>
                    <span className='f-header-close__line f-header-close__line--active'></span>
                    <span className='f-header-close__line f-header-close__line--active'></span>
                  </button>
                  <Slider ref={sliderRefM} {...sliderConf}>
                    <ForgetSection
                      handleNextButton={() => sliderRefM.current.slickNext()}
                      handlePhoneChars={value => setphoneLastCharacthers(value)}
                      handleWrongNumber={value => setWrongNumber(value)}
                      isWrongNumber={isWrongNumber}
                      isShowingLoader={isLoaderVisible}
                      handleToggleLoader={value => setLoaderVisible(value)}
                      countryPrefix={filteredCountry[0].prefijoTelefonico}
                      forgetType={0} />
                    <div>
                      <div className="f-form-remind">
                        <p>Hemos enviado tu correo electrónico al número celular. <br />
                          <span> �? �? �? �? �? �? �? �? {phoneLastCharacthers}</span></p>

                        <div className="f-footer-login">
                          <Icon tagtype="span" icon="icon-arrow-left f-arrow-left" size="1-2" onclick={() => sliderRefM.current.slickPrev()} />
                          <p onClick={() => { sliderRefM.current.slickPrev() }}>¡No me llegó el mensaje!</p>
                          <Button id='f-recoveryemail-submit-btn' type="button" onClickAction={() => { sliderRefM.current.slickPrev(); setContentToShow(0); }} classname="f-button f-button--primary" text="Confirmar" />
                        </div>
                      </div>
                    </div>
                  </Slider>
                </>
                :
                <>
                  {!isSended ?
                    <ForgetSection
                      isShowingLoader={isLoaderVisible}
                      handleToggleLoader={value => setLoaderVisible(value)}
                      handleChangeContent={value => setContentToShow(value)}
                      isRegisteredEmail={isRegisteredEmail}
                      handleRegisteredEmail={value => setRegisteredEmail(value)}
                      countryPrefix={filteredCountry[0].prefijoTelefonico}
                      forgetType={1} />
                    :
                    <AlertMessagge
                      icon={<img src={iconCheck} alt="check-correct" />}
                      messagge="ÉXITO"
                      description="Hemos enviado una contraseña temporal a su correo."
                      type="success"
                      button={<Button type="button" onClickAction={() => { setContentToShow(0); setSendedPass(false); }}
                        classname="f-button f-button--primary" text="CONFIRMAR" />} />
                  }
                </>
            }
          </HorizontalPopUp>
        </>
        :
        <></>
      }
    </header>
  )
};

export default Header;